// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  --box-shadow: none;
}

ion-toolbar {
  --padding-top: 4px;
  --padding-bottom: 4px;
  --min-height: 56px;
  font-size: 8px;
  margin-top: 5px;
}

ion-title {
  padding-left: 12px;
  padding-right: 12px;
  text-align: left;
}

ion-toggle {
  padding-right: 0 !important;
}

ion-input {
  padding-right: 0 !important;
}

.icon-toolbar {
  display: inline-block;
  vertical-align: middle;
}

.text-toolbar {
  vertical-align: middle;
  margin-left: 5px;
  font-size: 20px;
}

.text-introduction {
  font-size: 13px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 12px;
  width: 100%;
  display: block;
}

.item-has-focus .label-floating {
  color: var(--ion-color-light-contrast, #000) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/options-plant-specific/options-plant-specific.scss","webpack://./src/components/general%20components/options-plant-specific/options-plant-specific.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;ACCF;;ADEA;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;ACCF;;ADEA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;ACCF;;ADEA;EACE,2BAAA;ACCF;;ADEA;EACE,2BAAA;ACCF;;ADEA;EACE,qBAAA;EACA,sBAAA;ACCF;;ADEA;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;ACCF;;ADEA;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;ACCF;;ADGE;EACE,uDAAA;ACAJ","sourcesContent":["ion-button {\n  --box-shadow: none;\n}\n\nion-toolbar {\n  --padding-top: 4px;\n  --padding-bottom: 4px;\n  --min-height: 56px;\n  font-size: 8px;\n  margin-top: 5px;\n}\n\nion-title {\n  padding-left: 12px;\n  padding-right: 12px;\n  text-align: left;\n}\n\nion-toggle {\n  padding-right: 0!important;\n}\n\nion-input{\n  padding-right: 0!important;\n}\n\n.icon-toolbar {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.text-toolbar {\n  vertical-align: middle;\n  margin-left: 5px;\n  font-size: 20px;\n}\n\n.text-introduction {\n  font-size: 13px;\n  margin-top: 8px;\n  padding-left: 12px;\n  padding-right: 12px;\n  width: 100%;\n  display: block;\n}\n\n.item-has-focus {\n  .label-floating {\n    color: var(--ion-color-light-contrast, #000) !important;\n  }\n}\n","ion-button {\n  --box-shadow: none;\n}\n\nion-toolbar {\n  --padding-top: 4px;\n  --padding-bottom: 4px;\n  --min-height: 56px;\n  font-size: 8px;\n  margin-top: 5px;\n}\n\nion-title {\n  padding-left: 12px;\n  padding-right: 12px;\n  text-align: left;\n}\n\nion-toggle {\n  padding-right: 0 !important;\n}\n\nion-input {\n  padding-right: 0 !important;\n}\n\n.icon-toolbar {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.text-toolbar {\n  vertical-align: middle;\n  margin-left: 5px;\n  font-size: 20px;\n}\n\n.text-introduction {\n  font-size: 13px;\n  margin-top: 8px;\n  padding-left: 12px;\n  padding-right: 12px;\n  width: 100%;\n  display: block;\n}\n\n.item-has-focus .label-floating {\n  color: var(--ion-color-light-contrast, #000) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
